export default __webpack_public_path__ + "static/media/8.a96f4841.png";